if (!customElements.get('floating-form')) {
    class FloatingForm extends HTMLElement {
    constructor() {
        super();
        this.form = document.getElementById(`product-form-${this.dataset.section}`);
    //     product-form-template--15086110244937__main-product
    //     template--15086110244937__main-product
    //     let addToCart = document.querySelector('.template-product .cta-content');
    //     let addToCartForm = document.querySelector('.template-product .shopify-product-form .js-qty');
        this.observer = new IntersectionObserver((entries, observer) => { 
        entries.forEach(entry => {
            if(entry.intersectionRatio!=1){
                this.classList.add('active');
            }
            else {
                this.classList.remove('active');
            }
        });
        }, {threshold: 1});
        if(this.form) {
            this.observer.observe(this.form);
        }
    }

    }

    customElements.define('floating-form', FloatingForm);
}